<p-toast></p-toast>
<div class="page-wrapper my-account-page">
  <div class="wrap-breadcrumb">
    <div class="container">
      <div class="breadcrumb">
        <div>
          <a style="margin-right: 2px;" routerLink="/">Accueil</a> > Mon compte
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="my-account-page-inner">
      <div class="wrap-title d-flex align-items-center justify-content-between gap-2">
        <h2 class="title p-0 m-0">MON COMPTE</h2>
        <div class="group-btn d-flex gap-3">
          <button (click)="changePassword()" class="btn-common btn-change-pass">MODIFIER LE MOT DE PASSE</button>
          <button [disabled]="formUser.invalid" (click)="save()" class="btn-common btn-save">ENREGISTRER</button>
        </div>
      </div>
      <div class="wrap-content-tab">
        <p-tabView>
          <p-tabPanel header="Informations personelles" class="text-end">
            <div class="wrap-tab tab-1">
              <p class="title text-left">Informations personnelles</p>
              <form [formGroup]="formUser" class="">
                <div class="wrap-form row">
                  <div class="mb-2 col-md-12 col-lg-6 p-1 col-xl-4">
                    <div class="wrap-input">
                      <label for="">Nom</label>
                      <input formControlName="nom" type="text" placeholder="Nom" />
                    </div>
                  </div>
                  <div class="mb-2 col-md-12 col-lg-6 p-1 col-xl-4">
                    <div class="wrap-input">
                      <label for="">Prénom</label>
                      <input formControlName="prenom" type="text" placeholder="Prénom" />
                    </div>
                  </div>
                  <div class="mb-2 col-md-12 col-lg-6 p-1 col-xl-4">
                    <div class="wrap-input">
                      <label for="">Adresse e-mail de connexion</label>
                      <input class="disabled" formControlName="email" type="text" placeholder="Adresse e-mail" />
                    </div>
                  </div>
                  <div class="mb-2 col-md-12 col-lg-6 p-1 col-xl-6">
                    <div class="wrap-input">
                      <label for="">Téléphone</label>
                      <input formControlName="tel" type="text" placeholder="Téléphone" />
                    </div>
                  </div>
                  <div class="mb-2 col-md-12 col-lg-6 p-1 col-xl-6">
                    <div class="wrap-input">
                      <label for="">Fonction</label>
                      <input formControlName="func" type="text" placeholder="Fonction" />
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <a (click)="showDialogDelAccount()" class="text-cancel">Se désinscrire ? Cliquer ici</a>
          </p-tabPanel>
        </p-tabView>
      </div>
    </div>
  </div>
</div>
<p-dialog header="CHANGE PASSWORD" [modal]="true" [(visible)]="visible" [style]="{ width: '600px' }">
  <div class="popup-change-pass">
    <form [formGroup]="changePasswordForm" class="">
      <div class="d-flex mb-2 flex-wrap">
        <div class="col-xl-4 col-lg-4 col-12 px-2 mb-2">
          <div [ngClass]="{'is-invalid': submitted && f['password'].errors}" class="wrap-input">
            <label for="">Current pass</label>
            <input formControlName="password" [type]="showCurrentPassword ? 'text' : 'password'"
              placeholder="Current pass" [ngClass]="{'is-invalid': submitted && f['password'].errors}" />
            <button (click)="togglePassword('current')">
              <i *ngIf="showCurrentPassword" class="pi pi-eye show" style="font-size: 1.5rem"></i>
              <i *ngIf="!showCurrentPassword" class="pi pi-eye-slash hide" style="font-size: 1.5rem"></i>
            </button>
            <div *ngIf="submitted && f['password'].errors" class="invalid-feedback">
              Your password must contain at least 8 characters including 1 number and 1 special character minimum
            </div>
          </div>

        </div>
        <div class="col-xl-4 col-lg-4 col-12 px-2 mb-2">
          <div [ngClass]="{'is-invalid': submitted && f['newPassword'].errors}" class="wrap-input">
            <label for="">New pass</label>
            <input formControlName="newPassword" [type]="showNewPassword ? 'text' : 'password'"
              [ngClass]="{'is-invalid': submitted && f['newPassword'].errors}" placeholder="New pass" />
            <button (click)="togglePassword('new')">
              <i *ngIf="showNewPassword" class="pi pi-eye show" style="font-size: 1.5rem"></i>
              <i *ngIf="!showNewPassword" class="pi pi-eye-slash hide" style="font-size: 1.5rem"></i>
            </button>
            <div *ngIf="submitted && f['newPassword'].errors" class="invalid-feedback">
              Your password must contain at least 8 characters including 1 number and 1 special character minimum
            </div>
          </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-12 px-2">
          <div [ngClass]="{'is-invalid': submitted && f['confirmPassword'].errors}" class="wrap-input">
            <label for="">Confirm new pass</label>
            <input formControlName="confirmPassword" [type]="showConfirmPassword ? 'text' : 'password'"
              [ngClass]="{'is-invalid': submitted && f['confirmPassword'].errors}" placeholder="Confirm new pass" />
            <button (click)="togglePassword('confirm')">
              <i *ngIf="showConfirmPassword" class="pi pi-eye show" style="font-size: 1.5rem"></i>
              <i *ngIf="!showConfirmPassword" class="pi pi-eye-slash hide" style="font-size: 1.5rem"></i>
            </button>
            <div *ngIf="f['confirmPassword'].hasError('notMatch')" class="invalid-feedback">
              Confirm passwords do not match with new password
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="d-flex justify-content-end px-2">
      <button (click)="onSubmitChangePass()" class="btn-common btn-save py-2">ENREGISTRER</button>
    </div>
  </div>
</p-dialog>
<p-dialog header="SUPPRIMER LE COMPTE" [modal]="true" [(visible)]="visiblePopupDelAccount" [style]="{ width: '600px' }">
  <div class="popup-del-acc">
    <div class="d-flex mb-2 flex-wrap">
      <form [formGroup]="confirmDelAccForm" class="w-100">
        <div class="col-12 px-2 mb-2">
          <div class="wrap-input">
            <label for="">Mot de passe actuel</label>
            <input formControlName="password" [type]="showCurrentPassword ? 'text' : 'password'" type="text"
              placeholder="Current pass" />
            <button (click)="togglePassword('current')">
              <i *ngIf="showCurrentPassword" class="pi pi-eye show" style="font-size: 1.5rem"></i>
              <i *ngIf="!showCurrentPassword" class="pi pi-eye-slash hide" style="font-size: 1.5rem"></i>
            </button>
          </div>
        </div>

        <div class="col-12 px-2">
          <div class="wrap-input">
            <label for="">Raison</label>
            <textarea formControlName="reason" class="w-100" type="text" rows="4"></textarea>
          </div>
        </div>
      </form>
    </div>
    <div class="d-flex justify-content-end px-2">
      <button (click)="delAcc()" class="btn-common btn-save py-2">ENREGISTRER</button>
    </div>
  </div>
</p-dialog>